import React from 'react';
import './style.scss';

/**
 * POI Icon
 *
 * 目前只实现了通用样式，对其端内应该是按照种类展示不同的样式
 */
export default function POIIcon() {
  return <span className="l8-poi-anchor-icon" />;
}
